<iframe
  title="minicrm"
  src="https://r3.minicrm.hu/Form-43169-1kzj8ofb4u0wkp4ciojv"
  id="sidenav-newsletter-block"
  height="400px"
  width="100%"
  style="border: none"
></iframe>
